import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import VehicleList from './VehicleList';

const VehiclePage = (props) => {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <Route exact path={path}>
                <VehicleList {...props} />
            </Route>
            <Route exact path={`${path}/:vehicleId`}>
                <VehicleList {...props} />
            </Route>
        </Switch>
    );
};

export default VehiclePage;
